import React, { useState } from 'react';
import styled from 'styled-components'

import { PageHeader } from '@components/Text';
import Layout from '@components/Layout';
import { FullBleedPadding } from '@components/ContentPadding';
import ImageModal from '@components/ImageModal';
import { Button } from '@components/Button';

import { useRouter } from 'next/router';
import { BookOverview } from '../components/whoWeAre/BookOverview';

const Description = styled.div`
  margin-bottom: 40px;
  text-align: left;
  font-size: 24px;
  padding-left: 1%;
`;

// const PageText = styled.div`
//   text-align: left;
//   font-size: 24px;
//   margin-bottom: 60px;
// `;

const BuyButtonCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
`;

// const CollectionWrapper = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
// `;

const ButtonText = styled.div`
  font-size: 25px;
  margin: 20px;
`;

export default function WhoWeAre() {
  const router = useRouter()

  const [imgDisplayId, setImgDisplayId] = useState(null); 

  const imageContext = require.context('public/whoWeAre/collections', false);
  const imageArr = imageContext.keys();

  const parsedImageArr = imageArr.map((img, index) => ({
    id: index,
    src: `/whoWeAre/collections/${img}`,
    width: 'image', 
    metaDataImagePath: `/whoWeAre/collections/${img}`, 
    imageAttributes: [{trait_type: 'Artist', value: img}],
    type: 'image'
  }));
  

  const goToCheckout = () => router.push('/checkout');
  const handleCreditCard = () => window.open("https://lossumergidos.com/", "_blank");

  return (
    <Layout noFooter>
      <div className="bg-white overflow-hidden mx-20">
        <FullBleedPadding className="mx-auto text-center justify-around flex flex-wrap">
          <div className="w-full" style={{position: 'relative'}}>
            <PageHeader>
                Who We Are - The book
      
            </PageHeader>
            <Description>
              In a collaboration with Setanta Books, Obscura published the 200 legendary Who We Are portraits in a top-quality collector’s item: 800 pages, 200x160 mm, with fold-out pages.
              <br />
              <br /> There are 200 different covers available. If you would like a specific one, please include it in your order notes.
            </Description>
            <BookOverview />
            <BuyButtonCont>
              <Button style={{width: '300px', margin: '0px 20px 0px 20px', borderRadius: 5, height: 60}} onClick={goToCheckout}>
                <ButtonText>
                  Pay with ETH
                </ButtonText>
              </Button>
              <Button style={{width: '300px', margin: '0px 20px 0px 20px', marginLeft: 10,borderRadius: 5, height: 60}} onClick={handleCreditCard}>
                <ButtonText>
                  Pay with credit card
                </ButtonText>
              </Button>
            </BuyButtonCont>
              {/* <PageText>

                <span style={{fontWeight: 'bold'}}>Pay with Credit Card</span>: Price $75, shipping included
                <br />
                <br />
                <span style={{fontWeight: 'bold'}}>Or pay with Crypto</span>: 0.123 ETH, which guarantees you the Who We Are book + an extra airdrop of one of the Obscura founders’ works for the World Today 
              </PageText> */}

          </div>

          {/* <CollectionWrapper>
            <FreeNftGallery />
          </CollectionWrapper> */}

        </FullBleedPadding>
      </div>
      {
        imgDisplayId && (
          <ImageModal 
            collectionImages={parsedImageArr}
            displayIdx={imgDisplayId}
            setDisplayIdx={setImgDisplayId}
            setShowModal={() => {
              setImgDisplayId(null);
            }}
          />
        )
      }
      
    </Layout>


  );
}
